import createLogger from 'vuex/dist/logger';
export default function (debug) {
  var plugins = [];
  if (debug) {
    var devPlugins = [];
    if (process.browser) {
      devPlugins.push(createLogger());
    }
    plugins = devPlugins;
  } else {
    plugins = plugins.concat([]);
  }
  return plugins;
}